import styled from '@emotion/styled';

export const BreadcrumbItemStyled = styled.span`
  & span {
    font-weight: normal;
  }
`;
